/*
 * @Description: mark
 * @Author: wangwangwang
 * @Date: 2020-09-07 17:19:32
 * @LastEditors: wangwangwang
 * @LastEditTime: 2020-11-28 10:37:50
 */
import request from "@/utils/request";
/**
 * @Description: 新增或修改默认工艺流程
 * @Param:
 * @Author: wangwangwang
 * @param {*} data
 */
export function saveOrUpdate(data) {
  return request({
    url: "/icps/system/sign/basics/defaultPoint/saveOrUpdate",
    method: "post",
    data,
  });
}
/**
 * @Description: 修改站点的工艺流程
 * @Param:
 * @Author: wangwangwang
 * @param {*} data
 */
export function updatePointData(data) {
  return request({
    url: "/icps/system/sign/basics/technological/saveOrUpdate",
    method: "post",
    data,
  });
}
export function getPointData(params) {
  return request({
    url: "/icps/system/sign/basics/defaultPoint/queryOne",
    method: "get",
    params,
  });
}
/**
 * @Description: 获取站点的管控点
 * @Param:
 * @Author: wangwangwang
 * @param {*} params
 */
export function queryProcesses(data) {
  return request({
    url: "/icps/system/sign/basics/technological/queryProcesses",
    method: "post",
    data,
  });
}
/**
 * @Description: 查询异常推送人员
 */
export function getExceptionUser(data) {
  return request({
    url: "/icps/system/sign/basics/defaultPoint/getExceptionUser",
    method: "post",
    data,
  });
}
/**
 * @Description: 设置异常推送人员
 */
export function saveExceptionUser(data) {
  return request({
    url: "/icps/system/sign/basics/defaultPoint/saveExceptionUser",
    method: "post",
    data,
  });
}
// 余料比例设置查询
export function selectCloutSetting(data) {
  return request({
    url: "/icps/system/sign/basics/plan/selectCloutSetting",
    method: "post",
    data,
  });
}
// 余料比例设置修改
export function updateCloutSetting(data) {
  return request({
    url: "/icps/system/sign/basics/plan/updateCloutSetting",
    method: "post",
    data,
  });
}
// 产品设置查询
export function queryProduct(data) {
  return request({
    url: "/icps/system/sign/basics/technological/queryProduct",
    method: "post",
    data,
  });
}
// 产品设置保存
export function saveProduct(data) {
  return request({
    url: "/icps/system/sign/basics/technological/saveProduct",
    method: "post",
    data,
  });
}
// 获取站点生产线列表
export function queryLineByStation(data) {
  return request({
    url: "/icps/system/sign/basics/station/queryLineByStation",
    method: "post",
    data,
  });
}
// 获取生产线设置列表
export function queryLineGroup(data) {
  return request({
    url: "/icps/system/sign/basics/technological/queryLineGroup",
    method: "post",
    data,
  });
}
// 保存生产线设置列表
export function saveLineGroup(data) {
  return request({
    url: "/icps/system/sign/basics/technological/saveLineGroup",
    method: "post",
    data,
  });
}
// 富余量设置查询
export function queryLimit(data) {
  return request({
    url: "/icps/system/sign/basics/technological/queryLimit",
    method: "post",
    data,
  });
}
// 富余量设置保存
export function saveLimit(data) {
  return request({
    url: "/icps/system/sign/basics/technological/saveLimit",
    method: "post",
    data,
  });
}
